import { render, staticRenderFns } from "./ModelMenu.vue?vue&type=template&id=1c0bd1d6&"
import script from "./ModelMenu.vue?vue&type=script&lang=ts&"
export * from "./ModelMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports